var map = {
	"./1200 MK2.png": "27d8",
	"./1200 MK3D.png": "a066",
	"./1210 GR.png": "b945",
	"./1210 MK3 G.png": "69c1",
	"./1210 MK7 EX.png": "3ad6",
	"./45 Puck.png": "5b2f",
	"./Slipmat Gold.png": "4bd6",
	"./Slipmat Purple.png": "8991",
	"./Stylus Concorde Pro G.png": "d9be",
	"./Stylus Concorde Pro S.png": "966a",
	"./Stylus Stanton C.png": "f897",
	"./Tonearm Black.png": "e4d3",
	"./Tonearm Generic.png": "10cd",
	"./Weight Black.png": "80c0",
	"./Weight C.png": "3972"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5feb";